import { Route, Routes } from "react-router-dom";

import NotificationListScreen from "screens/App/CRM/Notification/NotificationListScreen";

const NotificationRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<NotificationListScreen />} />
    </Routes>
  );
};

export default NotificationRouter;
